module.exports = __webpack_public_path__ + "media/public/images/icon-filter-triangle-normal-03f253170a5cbdd68c1c0cf7054a6ea0.svg";